<template>
	<div class="page-content">
		<div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>知识产权投诉</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
		<div class="drawer-subtitle g-between">
			<div style="font-size: 16px;color: #333333;display: flex;">
				<div class="iconDiv" style="margin-top: -2px;">
					.
				</div>
				日常违规检索数据概览
			</div>
			<div>
				<el-radio-group v-model="radio1" size="mini" @change="onClick()">
					<el-radio-button label="今日"></el-radio-button>
					<el-radio-button label="近七日"></el-radio-button>
					<el-radio-button label="近三十日"></el-radio-button>
					<el-radio-button label="近一年"></el-radio-button>
				</el-radio-group>
				<el-date-picker
					style="width: 220px;margin-left: 20px;"
					size="mini"
					value-format="yyyy-MM-dd"
					v-model="committime"
					type="daterange"
					range-separator="~"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
			</div>
		</div>

		<el-card class="complaint-summary complaint-card" :body-style="{ padding: '0px' }" shadow="nerver">
			<el-row :gutter="10">
				<el-col class="g-column-center complaint-item" :span="5">
					<span style="color: #666;">
						投诉链接总量
					</span>
					<span class="complaint-number" style="font-size: 30px;">
						{{allcount}}
					</span>
				</el-col>
				<el-col class="g-column-center" :span="4">
					<span style="color: #666;">
						阿里知产投诉
					</span>
					<span class="complaint-number">
						{{ALcount}}
					</span>
					<span style="color: #666;">
						{{ALPercentage}}%
					</span>
				</el-col>
				<el-col class="g-column-center" :span="4">
					<span style="color: #666;">
						京东知产投诉
					</span>
					<span class="complaint-number">
						{{JDcount}}
					</span>
					<span style="color: #666;">
						{{JDPercentage}}%
					</span>
				</el-col>
				<el-col class="g-column-center" :span="4">
					<span style="color: #666;">
						苏宁知产投诉
					</span>
					<span class="complaint-number">
						{{SNcount}}
					</span>
					<span style="color: #666;">
						{{SNPercentage}}%
					</span>
				</el-col>
				<el-col class="g-column-center" :span="4">
					<span style="color: #666;">
						拼多多知产投诉
					</span>
					<span class="complaint-number">
						{{PDDcount}}
					</span>
					<span style="color: #666;">
						{{PDDPercentage}}%
					</span>
				</el-col>
				<el-col class="g-column-center" :span="3">
					<span @click="onTurnToDetail" class="complaint-btn">
						查看违规通知详情
					</span>
				</el-col>
			</el-row>
		</el-card>
			<el-row>
				<el-col :span="12" style="margin-bottom: 20px;padding-right: 20px;">
					<div class="fontStyle">
						<div class="iconDiv">
							.
						</div>
						知识产权投诉商品链接涉及产品排名
					</div>
					<el-card class="box-card" style="margin-top: 20px;">
						<div class="fontSizeStyle">
							平台
	            <el-select size="small" v-model="platform" placeholder="全部" style="width: 190px;margin-left: 15px;" @change="getComplaintProduct">
								<el-option label="全部" value=""></el-option>
								<el-option v-for="item in plateList" :key="item.dictCode" :value="item.dictCode" :label="item.dictName" v-show="item.pricename">
	              </el-option>
	            </el-select>
							<div class="iconStyle">
								<i class="el-icon-download" style="cursor: pointer;" @click="downTable"></i>
							</div>
						</div>
						<el-table :data="tableData" style="margin-top: 10px;min-height: 500px;" size="mini">
							<el-table-column prop="date" label="排名">
								<template slot-scope="scope">
									<span class="ranking" v-if="scope.row.rank == 1 || scope.row.rank == 2 || scope.row.rank == 3">
										{{scope.row.rank}}
									</span>
									<span v-else style="margin-left: 7px;">
										{{scope.row.rank}}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="productname" label="产品">
							</el-table-column>
							<el-table-column prop="count" label="链接数">
							</el-table-column>
						</el-table>
						<div>
							<pagination
								:currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
								:total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
							</pagination>
						</div>
					</el-card>
				</el-col>
				<el-col :span="12" style="margin-bottom: 20px;">
					<div class="fontStyle">
						<div class="iconDiv">
							.
						</div>
						店铺违规链接数量排名情况
					</div>
					<el-card class="box-card" style="margin-top: 20px;">
						<div class="fontSizeStyle">
							平台
	            <el-select size="small" v-model="platform2" placeholder="全部" style="width: 190px;margin-left: 15px;" @change="getComplaintShop">
								<el-option label="全部" value=""></el-option>
	              <el-option v-for="item in plateList" :key="item.dictCode" :value="item.dictCode" :label="item.dictName" v-show="item.pricename">
	              </el-option>
	            </el-select>
							<div class="iconStyle">
								<i class="el-icon-download" style="cursor: pointer;" @click="downTable2"></i>
							</div>
						</div>
						<el-table :data="tableData2" style="margin-top: 10px;min-height: 500px;" size="mini">
							<el-table-column prop="date" label="排名">
								<template slot-scope="scope">
									<span class="ranking" v-if="scope.row.rank == 1 || scope.row.rank == 2 || scope.row.rank == 3">
										{{scope.row.rank}}
									</span>
									<span v-else style="margin-left: 7px;">
										{{scope.row.rank}}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="company_memoname" label="平台" width="180">
								<template slot-scope="scope" >
									<div>
										{{scope.row.platform | platformChinese}}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="店铺" prop="shopname">
							</el-table-column>
							<el-table-column label="链接数" prop="count">
							</el-table-column>
						</el-table>
						<div>
							<pagination
								:currentPage="currentPage2" :pageSizes="[10, 20, 30, 40]"
								:total="totalNum2" @handleSizeChange="handleSizeChange2" @handleCurrentChange="handleCurrentChange2">
							</pagination>
						</div>
					</el-card>
				</el-col>
			</el-row>
	</div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
export default {
	name: 'Complaint',
	components: {
		pagination
	},
	data () {
		return {
			ALPercentage: 0,
			ALcount: 0,
			JDPercentage: 0,
			JDcount: 0,
			PDDPercentage: 0,
			PDDcount: 0,
			SNPercentage: 0,
			SNcount: 0,
			allcount: 0,
			platform: '',
			platform2: '',
			plateList: [],
			currentPage: 1,
			totalNum: 1,
			currentPage2: 1,
			totalNum2: 1,
			pageSize: 10,
			pageNo: 1,
			pageSize2: 10,
			pageNo2: 1,
			tableData: [],
			tableData2: [],
			committime: '',
			radio1: '近三十日'
		}
	},

	methods: {
		// 知识产权投诉数据概览
		getComplaintOverview() {
			let params={
				endtime: this.committime[0],
				starttime: this.committime[1],
			}
			fetch({
				url: "hcm/complaint/getComplaintOverview",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.ALPercentage = res.data.ALPercentage
					this.ALcount = res.data.ALcount
					this.JDPercentage = res.data.JDPercentage
					this.JDcount = res.data.JDcount
					this.PDDPercentage = res.data.PDDPercentage
					this.PDDcount = res.data.PDDcount
					this.SNPercentage = res.data.SNPercentage
					this.SNcount = res.data.SNcount
					this.allcount = res.data.allcount
				}
			})
		},
		// 下载
		downTable(){
			let datas={
				endtime: this.committime[0],
				starttime: this.committime[1],
				platform: this.platform
			}
			fetch({
					url: "hcm/complaint/downComplaintProduct",
					method: "get",
					params:datas,
					noFormat: true,
					responseType: "blob"
			})
			.then((res)=>{
				//下载
				let url = window.URL.createObjectURL(new Blob([res]))
				let link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', '知识产权投诉商品链接涉及产品排名.xlsx')
				document.body.appendChild(link)
				link.click()
			})
		},
		// 下载
		downTable2(){
			let datas={
				endtime: this.committime[0],
				starttime: this.committime[1],
				platform: this.platform2
			}
			fetch({
					url: "hcm/complaint/downComplaintShop",
					method: "get",
					params:datas,
					noFormat: true,
					responseType: "blob"
			})
			.then((res)=>{
				//下载
				let url = window.URL.createObjectURL(new Blob([res]))
				let link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', '店铺违规链接数量排名情况.xlsx')
				document.body.appendChild(link)
				link.click()
			})
		},
		// 知识产权投诉商品链接涉及产品排名
		getComplaintProduct() {
			let params={
				endtime: this.committime[0],
				starttime: this.committime[1],
				pageNo: this.pageNo,
				pageSize: this.pageSize,
				platform: this.platform
			}
			fetch({
				url: "hcm/complaint/getComplaintProduct",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.tableData = res.data.content
					this.totalNum = res.data.totalElements
				}
			})
		},
		// 知识产权投诉商品链接涉及产品排名
		getComplaintShop() {
			let params={
				endtime: this.committime[0],
				starttime: this.committime[1],
				pageNo: this.pageNo2,
				pageSize: this.pageSize2,
				platform: this.platform2
			}
			fetch({
				url: "hcm/complaint/getComplaintShop",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.tableData2 = res.data.content
					this.totalNum2 = res.data.totalElements
				}
			})
		},
		// 平台
		GetList() {
			let params={
				dictcode: 'platform',
				pricename: 'main',
			}
			fetch({
				url: "hcm/sys/GetList",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let {data}=res
				if(res.status == '10000'){
					this.plateList = res.data
				}
			})
		},
		handleSizeChange(val) {
			this.pageSize = `${val}`
			this.getComplaintProduct()
		},
		handleCurrentChange(val) {
			this.pageNo = `${val}`
			this.getComplaintProduct()
		},
		handleSizeChange2(val) {
			this.pageSize2 = `${val}`
			this.getComplaintShop()
		},
		handleCurrentChange2(val) {
			this.pageNo2 = `${val}`
			this.getComplaintShop()
		},
		// 日期选择
		onClick() {
			this.committime = []
			var n
			var nowdate = new Date();
      var y = nowdate.getFullYear();
      var m = nowdate.getMonth()+1;
      var d = nowdate.getDate();
      var formatnowdate = y+'-'+m+'-'+d;
			this.committime.push(formatnowdate)
			if (this.radio1 == '今日') {
				this.committime.push(formatnowdate)
			} else if (this.radio1 == '近七日') {
				n = 7
			} else if (this.radio1 == '近三十日') {
				n = 30
			} else if (this.radio1 == '近一年') {
				n = 365
			}
			if (n) {
				var oneweekdate = new Date(nowdate-n*24*3600*1000);
	      var y = oneweekdate.getFullYear();
	      var m = oneweekdate.getMonth()+1;
	      var d = oneweekdate.getDate();
	      var formatwdate = y+'-'+m+'-'+d;
				this.committime.push(formatwdate)
			}
			this.getComplaintProduct()
			this.getComplaintShop()
			this.getComplaintOverview()
    },
		onTurnToDetail() {
			this.$router.push({
				path: '/ComplaintDetail',
				query: { starttime: this.committime[1],endtime: this.committime[0]}
			});
		}
	},
	computed: {},

	created() {},

	mounted() {
		this.onClick()
		this.GetList()
		this.getComplaintProduct()
		this.getComplaintShop()
		this.getComplaintOverview()
	},
}
</script>


<style lang='scss'>
.fontSizeStyle {
	font-size: 14px;
	color: #333333;
	height: 32px;
	line-height: 32px;
}
.fontStyle {
	font-size: 16px;
	color: #333333;
	display: flex;
	margin-top: 20px;
}
.iconStyle {
	text-align: right;
	font-size: 20px;
	float: right;
	margin-right: 37px;
	color: #409eff;
}
.complaint-item {
	border-right: 1px solid rgb(218, 218, 218);
}
.ranking {
	width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #bda571;
  display: inline-block;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
}
.iconDiv {
	width: 5px;
	background-color: #333333;
	margin-right: 10px;
	height: 21px;
	margin-top: 4px;
}

.complaint-summary {
	padding: 50px;

	.complaint-number {
		font-size: 18px;
		color: #333;
	}

	.complaint-btn {
		color: #409eff;
		cursor: pointer;
	}
}

.complaint-summary .g-column-center {
	height: 80px;
}
@import "style/activityApproval.scss";
@import "style/activityApprovalSetting.scss";
</style>
